import i18n from "i18next";
import LanguageDetector from "i18next-browser-languagedetector";
import { initReactI18next } from "react-i18next";

// i18next-http-backend намеренно НЕ подключён: переводы грузятся не по сети, а через
// require(`./_lang/${lang}.json`) в _helpers/language.js и MainPage.setLanguage.
// С бэкендом каждый старт давал 404 на /locales/{lng}/translation.json — лишний
// запрос в никуда, особенно заметный в WebView мобильного приложения.
i18n
  // Автоматическое определение языка
  .use(LanguageDetector)
  // модуль инициализации
  .use(initReactI18next)
  .init({
    // Стандартный язык
    fallbackLng: "en",
    debug: process.env.NODE_ENV === "development",
    // Распознавание и кэширование языковых кук
    detection: {
      order: ["queryString", "cookie"],
      cache: ["cookie"],
    },
    interpolation: {
      escapeValue: false,
    },
  });

export default i18n;
